export default __webpack_public_path__ + "static/media/icon-frame-top3.098784ee.svg";